import { render, staticRenderFns } from "./TaInput.vue?vue&type=template&id=477c6e00&"
import script from "./TaInput.vue?vue&type=script&lang=js&"
export * from "./TaInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports